module.exports = __webpack_public_path__ + "img/dummy.9055250f.svg";